module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/083-somalia-40e2bc44f864cc6170828735ed97fd6c.svg";